module.exports = __webpack_public_path__ + "static/undraw_Group_chat_unwm-bcdbf0b830eb2f23b6c197e02cbac69d.svg";